import { render, staticRenderFns } from "./ContributorAdd.vue?vue&type=template&id=7b2ba828&"
import script from "./ContributorAdd.vue?vue&type=script&lang=js&"
export * from "./ContributorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports